import React from "react";

const DatesButtons = ({ onDatesBtnClick, dates }) => {
  return (
    <div className="afisha-search_selection__dates">
      {Object.keys(dates).map(
        (key, i) =>
          i === 0 && (
            <button
              key={i}
              className={`afisha_btn${dates[key].classObject}`}
              onClick={() =>
                onDatesBtnClick(i, dates[key].id, "dates", dates[key].text)
              }
            >
              {dates[key].text}
            </button>
          )
      )}
      <div>
        {Object.keys(dates)
          .map(
            (key, i) =>
              i !== 0 && (
                <button
                  key={i}
                  className={`afisha_btn${dates[key].classObject}`}
                  onClick={() =>
                    onDatesBtnClick(i, dates[key].id, "dates", dates[key].text)
                  }
                >
                  {dates[key].text}
                </button>
              )
          )
          .reverse()}
      </div>
    </div>
  );
};

export default DatesButtons;



// WEBPACK FOOTER //
// ./src/components/Events/DatesButtons.js